/* Seaside theme — light client-side interactions */
document.addEventListener('DOMContentLoaded', function () {
  // Sticky-header scroll state
  var header = document.querySelector('.site-header');
  if (header) {
    var toggleScrolled = function () {
      if (window.scrollY > 8) header.classList.add('scrolled');
      else header.classList.remove('scrolled');
    };
    toggleScrolled();
    window.addEventListener('scroll', toggleScrolled, { passive: true });
  }

  // Mobile nav toggle
  var toggle = document.querySelector('[data-mobile-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }

  // Search drawer
  var searchBtn = document.querySelector('[data-search-toggle]');
  var searchDrawer = document.querySelector('[data-search-drawer]');
  if (searchBtn && searchDrawer) {
    searchBtn.addEventListener('click', function (e) {
      e.preventDefault();
      searchDrawer.classList.toggle('open');
      var input = searchDrawer.querySelector('input[type="search"]');
      if (input) setTimeout(function () { input.focus(); }, 150);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') searchDrawer.classList.remove('open');
    });
  }

  // Product image gallery swap
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (main) {
          main.src = thumb.getAttribute('data-full') || thumb.src;
          main.alt = thumb.alt;
        }
      });
    });
  });

  // FAQ accordion — browser default <details> handles it.
});
